import {GEAR} from './character';
import combatContent from '../../../data/thai-combat-content.json';
import economyContent from '../../../data/thai-hunt-economy.json';
import femaleGhosts from '../../../data/female-ghosts.json';
// Display-only registry. Unknown IDs never become arbitrary asset URLs.
const symbols=['inventory','equipment','status','identity','skill','pet','hotbar','trade','quest','map','town','mail','settings','travel','eye','potion','capture','spirit','material','revive','unknown'] as const;
export const UI_ICONS:Readonly<Record<string,string>>=Object.freeze(Object.fromEntries(symbols.map(id=>[id,`/assets/ui/gq-v001/${id}.svg`])));
const reported=new Set<string>();
function missing(domain:string,id:string):string{
 const key=domain+':'+id;
 // Bound warnings during repeated snapshots and malformed save imports.
 if(!reported.has(key)&&reported.size<128){reported.add(key);console.warn('[PHI icon] Missing semantic ID',domain,id);}
 return UI_ICONS.unknown!;
}
export const uiIcon=(name:string):string=>Object.hasOwn(UI_ICONS,name)?UI_ICONS[name]!:missing('ui',name);
const itemSymbols:Readonly<Record<string,string>>=Object.freeze({potion:'potion','capture-talisman':'capture','warp-talisman':'travel','nine-lives':'revive','starter-pet-box':'pet'});
const materialIds=new Set([...Object.values(combatContent.ghosts).flatMap(ghost=>ghost.drops.map(drop=>drop.itemId)),...economyContent.recipes.map(recipe=>recipe.output.itemId)]);
const ghostIds=new Set([...Object.keys(combatContent.ghosts),...femaleGhosts.map(ghost=>ghost.id),'nang-kwak','kuman-thong']);
export function itemIcon(id:string):string{
 const gear=GEAR.find(g=>g.id===id);
 if(gear)return `/assets/ui/gq-equipment-v001/${gear.id}.svg`;
 if(Object.hasOwn(itemSymbols,id))return uiIcon(itemSymbols[id]!);
 const ghost=id.startsWith('ghost-specimen-')?id.slice(15):id.startsWith('bound-ghost-')?id.slice(12):undefined;
 if(ghost&&ghostIds.has(ghost))return uiIcon('spirit');
 if(materialIds.has(id))return uiIcon('material');
 return missing('item',id);
}
export const escapeUi=(s:string):string=>s.replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]!));
